export const getProgramByLicenseName = (licenseName: string) => {
  const nameParts = licenseName.split(" ")

  if (licenseName.toLowerCase().includes("keys")) {
    return "workkeys"
  }
  if (nameParts.includes("Playbook")) {
    return "playbook"
  }
  // Check for standard ACT first, before EACT
  if (
    nameParts.includes("ACT") &&
    licenseName.toLowerCase().includes("middle school")
  ) {
    return "actms"
  }
  if (
    (nameParts.includes("ACT") && !nameParts.includes("EACT")) ||
    nameParts.includes("Aspire")
  ) {
    return "act"
  }
  // Check EACT after standard ACT
  if (nameParts.includes("EACT")) {
    return "eact"
  }
  if (nameParts.includes("PSAT")) {
    return "psat"
  }
  if (nameParts.includes("STAAR")) {
    return "staar"
  }
  if (nameParts.includes("DSAT")) {
    return "dsat"
  }
  if (licenseName.includes("Digital SAT")) {
    return "dsat"
  }
  if (nameParts.includes("SAT")) {
    return "sat"
  }
  if (nameParts.includes("TSIA2")) {
    return "tsia2"
  }
  if (nameParts.includes("LEAP")) {
    return "leap"
  }
  if (nameParts.includes("FLEOC")) {
    return "fleoc"
  }
  if (nameParts.includes("KSA")) {
    return "ksa"
  }
  if (nameParts.includes("MAAP")) {
    return "maap"
  }
  if (nameParts.includes("NCEOC")) {
    return "nceoc"
  }
  if (nameParts.includes("CCRA")) {
    return "ccra"
  }
  if (nameParts.includes("TCAP")) {
    return "tcap"
  }
  if (nameParts.includes("CLT")) {
    return "clt"
  }
  if (nameParts.includes("EOCEP")) {
    return "eocep"
  }
  if (nameParts.includes("ISA")) {
    return "isa"
  }
  if (nameParts.includes("ILEARN")) {
    return "ilearn"
  }
  if (nameParts.includes("GMAS")) {
    return "gmas"
  }
  if (nameParts.includes("CMAS")) {
    return "cmas"
  }
  if (nameParts.includes("OST")) {
    return "ost"
  }
}
